import React from 'react';
import { Store } from 'api/types/store';
import { Button, SelectField, Typography } from 'ui-kit';
import { Controller, useForm } from 'react-hook-form';
import { PayoutMethod } from 'api/types/payout';
import { updateStoresPayoutMethod } from 'api/store';
import { message } from 'antd';

type Props = {
  stores?: Store[];
  payoutMethods?: PayoutMethod[];
};

export default function StorePayoutMethodsForm({ stores, payoutMethods }: Props) {
  const initialValues = stores?.map((store) => ({
    id: store.id,
    payoutMethod: store.payoutMethod,
  }));
  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty },
  } = useForm({
    mode: 'onChange',
    defaultValues: { stores: initialValues },
  });
  const payoutMethodOptions = payoutMethods
    ?.filter((payoutMethod) => payoutMethod.isActive)
    .map((payoutMethod) => ({
      label: payoutMethod.nickname,
      value: payoutMethod.id,
    }));
  const onSubmit = ({ stores }) => {
    const payload = stores.map((store) => ({
      id: store.id,
      payoutMethod: store.payoutMethod,
    }));
    updateStoresPayoutMethod({ stores: payload }).then((res) => {
      if (res.ok) {
        message.info('Store payout methods updated successfully!');
      } else {
        message.error(
          res.errors?.nonFields?.[0] ||
            'Something went wrong trying to update your store payout methods!',
        );
      }
      reset({ stores: payload });
    });
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="PayoutMethods_collapse-content">
        {stores?.map((store, index) => (
          <div className="PayoutMethods_store-select" key={store.id}>
            <Typography variant="subtitle1" as="span" className="PayoutMethods_store-select-label">
              {store.storeName}
            </Typography>
            <Controller
              control={control}
              name={`stores.${index}.payoutMethod`}
              render={({ field }) => (
                <SelectField
                  className="PayoutMethods_store-select-input"
                  options={payoutMethodOptions}
                  {...field}
                />
              )}
            />
          </div>
        ))}
        <Button
          className="PayoutMethods_collapse-button"
          variant="contained"
          type="submit"
          disabled={!isDirty}
        >
          Save Changes
        </Button>
      </div>
    </form>
  );
}
